import type { BuffSkill } from '../../../battle/types';
import { playSfx } from '../../../render/utils/audio';
import type { SkillBundle } from '../../types';

const ROOT = '/assets/textures/characters/sparky_bot/skills/charge';

// Sheet layout - same 4x4 convention as the other skill / character sheets.
const SHEET_COLS = 4;
const SHEET_ROWS = 4;
// Sheet playback speed (overridable per character via timings.skills.
// charge.speed). No impact frame - the charge-up plays start to finish
// at this one speed, then the attack follows.
const ANIM_SPEED = 1;

const ENGINE: BuffSkill = {
  kind: 'buff',
  id: 'charge',
  name: 'Charge',
  // when charged, the next damaging swing this turn deals 50% more damage
  attackDamageMultiplier: 1.5,
  animationId: 'charge',
};

export const CHARGE: SkillBundle = {
  engine: ENGINE,
  assets: {
    sheets: {
      charge: { url: `${ROOT}/charge_v2.png`, cols: SHEET_COLS, rows: SHEET_ROWS },
    },
    textures: {
      logIcon: `${ROOT}/ui-log-icon.png`,
      logCircleIcon: `${ROOT}/ui-log-circle-icon.png`,
    },
    sfx: {
      charge: `${ROOT}/charge.mp3`,
    },
  },
  async playSelf(ctx) {
    const { actor, assets } = ctx;
    const frames = assets.sheets.charge;
    if (!frames) return;

    // Per-character overrides (speed / offset / scale) fall back to the
    // skill's built-in defaults. No impact frame - buff is not synced to a
    // follow-up event, it just plays whole.
    const t = actor.timings.skills?.[ENGINE.id];

    // In-place self animation - no lunge, no defender. Plays once at a single
    // speed; we await the FULL anim so the attack starts only after the
    // charge-up finishes (the attack anim then takes over - no idle snap).
    actor.playFrames(frames, {
      loop: false,
      speed: t?.speed ?? ANIM_SPEED,
      offsetX: t?.offsetX,
      offsetY: t?.offsetY,
      scaleMultiplier: t?.scale,
    });

    const sfx = assets.sfx.charge;
    if (sfx) playSfx(sfx);

    await actor.awaitAnimationComplete();
  },
};
